import { STORAGE_KEY } from './storage-key.token';

export const provideStorage = (key: string) => ({
    provide: STORAGE_KEY,
    useValue: key,
});
